import React from 'react'; 
import '../../../CSS/contact.scss';
// import '../../../CSS/main.scss';
import { Phone,Mail,Home } from 'react-feather';
const ContactContent = ({data})=> {
    // console.log(data);
    const phone = data[0].phone;
    const email = data[0].email;
    const house = data[0].location;
    // console.log(phone);
    // console.log(email);
    // console.log(house);
  return (
    <div className="container">
        <div className="row">
            <div className="col-md-4 col-lg-4"></div>
            <div className="col-md-4 col-lg-4">
                <h4 className="header_or_link_contact">GET IN TOUCH</h4>
            </div>
            <div className="col-md-4 col-lg-4"></div>
        </div>
        <div className="row">
            <div className="col-md-4 col-lg-2"></div>
            <div className="col-md-8 col-lg-8">
                <div className="display-content mt-3">
                    <span className="contact-icon"><i><Phone/></i></span>
                    <span className="contacts">
                    {phone.map((mobile,index)=>{
                        if(Number(index)===Number(phone.length - 1)) return `${mobile.number}`;
                        else return `${mobile.number} , `;    
                    })}
                    </span>
                </div>
                <div className="display-content mt-3">
                    <span className="contact-icon"><i><Mail/></i></span>
                    <span className="contacts">
                    {email.map((mail,index)=>{
                        if(Number(index)===Number(phone.length - 1)) return `${mail.address}`;
                        else return `${mail.address} , `;    
                    })}
                    </span>
                </div>
                <div className="display-content mt-3">
                    <span className="contact-icon"><i><Home/></i></span>
                    <span className="contacts">
                    {house.map((house,index)=>{
                        if(Number(index)===Number(house.length - 1)) return `${house.address}`;
                        else return `${house.address} , `;    
                    })}
                    </span>
                </div>
            </div>
            <div className="col-md-4 col-lg-2"></div>
        </div>
    </div>
  );
}

export default ContactContent; 